import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';


import { LabelsModule } from '@core/components/labels/labels.module';
import { CoreProjectsModule } from '@core/components/projects/projects.module';

import { ProjectsSummaryItemComponent } from './summary-item/summary-item.component';

@NgModule({
    imports: [
        CommonModule,
        LabelsModule,
        CoreProjectsModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectsSummaryItemComponent
    ],
    exports: [
        ProjectsSummaryItemComponent
    ],

})
export class AppProjectsSummaryModule{ }
